import { z } from 'zod';

import { ProductType } from '../../../types/Products';
import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalString,
    requiredString,
    SYNC_UPDATE_VALIDATION_SCHEMA,
    timestamp,
} from './common';

export const createProductAddSchema = () =>
    z
        .object({
            id: requiredString,
            name: requiredString,
            product_type: z.nativeEnum(ProductType),
            brand: optionalString,
            family: optionalString,
            shape: optionalString,
            dimensions: optionalString,
            clips: optionalString,
            shoe_size: optionalString,
            nail_size: optionalString,
            product_size: optionalString,
            sku_apac: optionalString,
            sku_emea: optionalString,
            uom_dealers: optionalString,
            created_at: timestamp,
            updated_at: timestamp,
            material: optionalString,
            shoe_size_sort_num: optionalString,
            box_unit_size: z.number(),
            organisation_id: requiredString,
            user_id: requiredString,
            not_available: z.boolean().nullable().optional(),
        })
        .strict();

export const createProductUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createProductAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.products,
    );

export const createProductDeleteSchema = () => createDeleteSchema();

export const createProductSchemas = () => ({
    add: createProductAddSchema(),
    update: createProductUpdateSchema(),
    delete: createProductDeleteSchema(),
});

export const productRawRecordSchema = createProductAddSchema();
